import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

// Custom cursor: dot + border circle (replaces native cursor)
export default function MagneticCursor() {
  const [enabled, setEnabled] = useState(false);

  const x = useMotionValue(0);
  const y = useMotionValue(0);

  // Create spring animations for smooth lagging effect
  const springConfig = { damping: 20, stiffness: 300 };
  const springX = useSpring(x, springConfig);
  const springY = useSpring(y, springConfig);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    // Check for fine pointer (mouse) AND not touch device AND not mobile screen size
    const hasFinePointer = window.matchMedia("(pointer: fine)").matches;
    const isTouchDevice =
      "ontouchstart" in window || navigator.maxTouchPoints > 0;
    const isMobileScreen = window.matchMedia("(max-width: 768px)").matches;

    if (!hasFinePointer || isTouchDevice || isMobileScreen) {
      setEnabled(false);
      return undefined;
    }

    setEnabled(true);

    // Hide native cursor
    document.body.style.cursor = "none";

    const handleMove = (event: MouseEvent) => {
      x.set(event.clientX);
      y.set(event.clientY);
    };

    window.addEventListener("mousemove", handleMove);
    return () => {
      window.removeEventListener("mousemove", handleMove);
      document.body.style.cursor = "";
    };
  }, [x, y]);

  // Hide on touch / non-fine pointers / mobile
  if (!enabled) return null;

  return (
    <>
      {/* Border circle */}
      <motion.div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          x: springX,
          y: springY,
          translateX: "-50%",
          translateY: "-50%",
          width: 72,
          height: 72,
          borderRadius: "999px",
          border: "1px solid rgb(62, 39, 72)",
          pointerEvents: "none",
          zIndex: 9999,
        }}
      />
      {/* Center diamond (rotated square) */}
      <motion.div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          x: springX,
          y: springY,
          translateX: "-50%",
          translateY: "-50%",
          width: 9,
          height: 9,
          backgroundColor: "rgb(62, 39, 72)",
          rotate: 45,
          pointerEvents: "none",
          zIndex: 10000,
        }}
      />
    </>
  );
}
